let mql = window.matchMedia('(min-width: 768px)');
if (mql.matches) {
    document.addEventListener('click', function (event) {
      const target = event.target.parentNode;

      if (target.classList.contains('snize-main-panel-dropdown-button')) {
        target.classList.toggle('opened');
        document.querySelector('.snize-search-results').classList.toggle('opened');
      }
      
      setSortingWrapperWidth();
      
    });
}

document.addEventListener('Searchanise.Loaded', function() {
    document.querySelector('.loading-wrapper').style.display = 'none';

    setTimeout(function() { doFunctions()}, 1000);
});

const observer = new MutationObserver(list => {
  // console.log('mutation list', list);
  let update = false;
  list.forEach(element => {
    
    // console.log(element.target);
    if(element.target.classList.contains('snize-price-list')) {
      update = true;
      return;
    }
    if(update) {
      let mql = window.matchMedia('(min-width: 768px)');
      if (mql.matches) {
          setSortingWrapperWidth();
      }
      updateProductLabels();
    }
  });

});
observer.observe(document.body, {attributes: false, childList: true, subtree: true});


function doFunctions() {

  let mql = window.matchMedia('(min-width: 768px)');
  if (mql.matches) {
      setSortingWrapperWidth();
  }
  addDataAttribute();
  updateProductLabels();
  initEvents();
}

function setSortingWrapperWidth() {
  const searchWrapper = document.querySelector('.snize-search-results');
  const sortingWrapper = document.querySelector('.snize-main-panel-dropdown-content');

  sortingWrapper.style.width = searchWrapper.getBoundingClientRect().width * 20 / 100 + 'px';
}


function updateProductLabels() {
  let products = document.querySelectorAll('.snize-product');
  Array.from(products).forEach((element, index) => {
    let imageWrapper = element.querySelector('.snize-thumbnail-wrapper');
    let itemWrapper = element.querySelector('.snize-item');
    let labelsWrapper = document.createElement('div');
    labelsWrapper.className = 'snize-labels-wrapper';
    
    if(imageWrapper.querySelectorAll('.snize-product-label')) {
      // example: wrapping an anchor with class "wrap_me" into a new div element
      Array.from(imageWrapper.querySelectorAll('.snize-product-label')).forEach(elem => {
        wrap(elem, labelsWrapper);
      });
    }
    
    if(element.querySelector('.snize-out-of-stock')) {
      labelsWrapper.appendChild(element.querySelector('.snize-out-of-stock'));
    }
  });
}

function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}



/*
** GTM add data-attribute
*/
function addDataAttribute() {
  const products = document.querySelectorAll('.snize-product');

  Array.from(products).forEach((element, index) => {
    const link = element.querySelector('.snize-view-link');
    const id = element.getAttribute('id').replace('snize-product-','');
    const variantId = element.getAttribute('data-product-variant');
    let product = [];
    let dataProductInfo, dataProductAdd;
    let title = element.querySelector('.snize-title').innerText;
    const priceElement = element.querySelector('.snize-price');
    let price = '';
    if(priceElement) {
      const priceSymbol = Searchanise.templates.PriceFormatSymbol;
      price = priceElement.innerText.replace(priceSymbol,'').replace(',','.');
    }
    let snizeColor = element.querySelector('.snize-option') ? element.querySelector('.snize-option') : false;
    let snizeSize = element.querySelectorAll('.snize-size') && element.querySelectorAll('.snize-size').length > 0 ? Array.from(element.querySelectorAll('.snize-size')) : false;
    let size = snizeSize ? snizeSize[0].getAttribute('data-value') : '';
    let color = snizeColor ? snizeColor.value : '';
    let variant = size + ' ' + color;
    let vendor = '', category = '';

    if(element.classList.contains('snize-product-tag-no_sell1')) {
      element.classList.add('snize-product-out-of-stock');
      element.classList.remove('snize-product-in-stock');
      sizes = element.querySelectorAll('.snize-size');
      Array.from(sizes).forEach((size) => {
        size.classList.add('snize-size-unavailable');
        size.classList.remove('snize-size-active');
      });
    }

    fetch('/products.json')
      .then((response) => response.json())
      .then((data) => {
          if(data && data.products) {
            product = Array.from(data.products).filter(element => element.id == id);
            const department = Array.from(product[0].tags).filter(element => element.indexOf('dept') != -1);
            let dept = department.length > 0 ? department[0].split('dept_')[1] : '';
            const productVariant = Array.from(product[0].variants).filter(element => element.id == variantId);
            title = product[0].title;
            price = productVariant[0].price;
            vendor = product[0].vendor;
            variant = productVariant[0].title;
            category = product[0].product_type ? product[0].product_type : dept;
          }

          dataProductInfo = {
            'id': id,
            'name': title,
            'price': price,
            'brand': vendor,
            'variant': variant,
            'category': category,
            'position': index + 1,
            'list': 'Search Results'
          };

          dataProductAdd = {
            'id': id,
            'name': title,
            'price': price,
            'brand': vendor,
            'variant': variant,
            'category': category,
            'quantity': '1'
          };

          link.setAttribute('data-product-info', JSON.stringify(dataProductInfo));

          Array.from(document.querySelectorAll('.snize-size')).forEach((element) => {
            element.setAttribute('data-product-add', JSON.stringify(dataProductAdd));
          });
      })
      .catch((e) => {
        console.error(e);
      });
  });
}

/*
** Add event listener
*/
function initEvents() {
    // Custom add to cart function with cartnotification
    const cartNotification = document.querySelector('cart-notification');
      Array.from(document.querySelectorAll('.snize-size')).forEach((element) => {
        element.addEventListener('click', function(event) {
          setTimeout(function() {
            let product = event.target.closest('.snize-product');
            let variantId = product.getAttribute('data-product-variant');
          
            cartNotification.setActiveElement(document.getElementById('MainContent'));

            const body = JSON.stringify({
              form_type: 'product',
              id: variantId,
              sections: cartNotification.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
            });

            fetch('/cart/add', { ...fetchConfig('javascript'), body })
              .then((response) => response.json())
              .then((parsedState) => {
                cartNotification.renderContents(parsedState);
              })
              .catch((e) => {
                console.error(e);
              })
          }, 100);
        });
      });
      
}
